// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"PlainQuote__srOnly--swGZr","hiddenInput":"PlainQuote__hiddenInput--CeIY5","root":"PlainQuote__root--3FXwI"};